var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-97247e8e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "panel-wrapper__content" };
const _hoisted_2 = { class: "form" };
const _hoisted_3 = { class: "section-wrapper" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1 /* HOISTED */));
const _hoisted_6 = { class: "text-right" };
import { ref } from "vue";
import { FileAssetMutable } from "src/shared/store/file/model/FileAssetMutable";
import { getErrorMessage } from "src/shared/store/common/Exception";
import UploadFileWrapper from "../../ui/file/UploadFileWrapper.vue";
import Dialog from "../../ui/Dialog.vue";
import Button from "../../ui/Button.vue";
import notificationService from "../../ui/notification/notification-service";
import { useCampaignControllerActionCreativeStore } from "src/shared/store/campaign/controller/action/creative";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UploadCreativeArchiveDialog',
    props: {
        creativeActionFrontendAsset: {}
    },
    emits: ["closed"],
    setup(__props, { emit: __emit }) {
        const campaignControllerActionCreativeStore = useCampaignControllerActionCreativeStore();
        const isOpen = ref(true);
        const props = __props;
        const emit = __emit;
        const fileAssetMutable = ref(new FileAssetMutable());
        const handleChange = (file) => {
            fileAssetMutable.value.file = file;
        };
        const handleFileRemove = () => {
            fileAssetMutable.value.file = undefined;
        };
        const isUploading = ref(false);
        const uploadCreativeArchive = () => __awaiter(this, void 0, void 0, function* () {
            if (!fileAssetMutable.value.file) {
                return;
            }
            try {
                isUploading.value = true;
                yield campaignControllerActionCreativeStore.uploadCreative({
                    campaignId: props.creativeActionFrontendAsset.getCampaignId(),
                    controllerId: props.creativeActionFrontendAsset.getStepId(),
                    actionId: props.creativeActionFrontendAsset.getActionId(),
                    file: fileAssetMutable.value.file
                });
                notificationService.success("Creative uploaded successfully");
            }
            catch (error) {
                notificationService.error(getErrorMessage(error));
            }
            finally {
                isUploading.value = false;
                emit("closed");
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(Dialog, {
                modelValue: isOpen.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((isOpen).value = $event)),
                onClosed: _cache[2] || (_cache[2] = ($event) => (emit('closed')))
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("h1", null, "Upload Creative to " + _toDisplayString(_ctx.creativeActionFrontendAsset.getDisplayName()), 1 /* TEXT */),
                        _createElementVNode("form", _hoisted_2, [
                            _createElementVNode("section", _hoisted_3, [
                                _createVNode(UploadFileWrapper, {
                                    "accept-formats": ['.zip'],
                                    onUploaded: handleChange,
                                    onRemoved: handleFileRemove
                                }, null, 8 /* PROPS */, ["accept-formats"])
                            ])
                        ]),
                        (fileAssetMutable.value.file)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                                _hoisted_5,
                                _createTextVNode(" You are about to upload "),
                                _createElementVNode("strong", null, _toDisplayString(fileAssetMutable.value.file.name), 1 /* TEXT */),
                                _createTextVNode(" to the "),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.creativeActionFrontendAsset.getDisplayName()), 1 /* TEXT */),
                                _createTextVNode(" zone. ")
                            ]))
                            : _createCommentVNode("v-if", true),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("a", null, [
                                _createVNode(Button, {
                                    "is-disabled": !fileAssetMutable.value.file,
                                    "is-pending": isUploading.value,
                                    onClick: _cache[0] || (_cache[0] = ($event) => (uploadCreativeArchive()))
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(" Upload ")
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["is-disabled", "is-pending"])
                            ])
                        ])
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"]));
        };
    }
});
